import { IdentityOptionList, IdentityInfo } from '@tt4b/ttam-enums/src/types';
import { ref } from '@vue/composition-api';
import { fetchIdentityListByPageApi, IdentityListParams } from '@tt4b/ttam-hooks';
import { createLogger } from '@tt4b/ttam-utils';
import { IDENTITY_TYPE_MAP } from '@tt4b/ttam-enums';

const logger = createLogger('CreativeIdentityList');

export const useIdentityPageList = ({
  identityType,
  identityAuthId = '',
  identityBcId = '',
  genListOptionsFunction,
}: {
  identityType: number;
  identityAuthId: string;
  identityBcId: string;
  genListOptionsFunction: any;
}) => {
  const page = ref(1);
  const limit = ref(20);
  const hasMore = ref(true);
  const cursor = ref(0);
  const listData: any = ref<IdentityOptionList[] & IdentityInfo[]>([]);
  const loading = ref(false);

  const getIdentityOptions = data => {
    if (typeof genListOptionsFunction === 'function') {
      return genListOptionsFunction(data) || data;
    }

    return data;
  };

  // 接口请求参数
  const getRequestParams = (): IdentityListParams => ({
    identityType,
    identityBcId,
    identityAuthId,
    limit: limit.value,
    page: page.value,
    cursor: cursor.value,
    isFilterInvalidCode: identityType === IDENTITY_TYPE_MAP.AUTH_CODE_USER,
  });

  const handleLoad = (): Promise<IdentityOptionList[]> => {
    loading.value = true;

    return fetchIdentityListByPageApi(getRequestParams())
      .then(result => {
        const { identityList = [], hasMore: _hasMore, cursor: _cursor } = result || {};
        // list格式format
        const _list = getIdentityOptions(identityList);
        listData.value = listData.value.concat(_list);
        hasMore.value = _hasMore;
        cursor.value = _cursor;
        loading.value = false;

        return _list;
      })
      .catch(err => {
        loading.value = false;
        logger.info('list onScrollBottom and load error', err);
        return [];
      });
  };

  const resetPageList = () => {
    page.value = 1;
    hasMore.value = true;
    cursor.value = 0;
    listData.value = [];
    loading.value = false;
  };

  return {
    page,
    limit,
    hasMore,
    cursor,
    listData,
    loading,

    handleLoad,
    resetPageList,
  };
};
